import { render, staticRenderFns } from "./CardArchiveKeo.vue?vue&type=template&id=4976d4cb&"
import script from "./CardArchiveKeo.vue?vue&type=script&lang=ts&"
export * from "./CardArchiveKeo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports